export { default } from './SpotlightSearch';
